module.exports = __webpack_public_path__ + "static/img/disp_item.b7f7420.png";


//////////////////
// WEBPACK FOOTER
// ./static/help-image/disp_item.png
// module id = 81
// module chunks = 1